module.exports = __webpack_public_path__ + "img/xiaomi13desk.a9975e4c.png";